export enum LocalesEnum {
  DUTCH = 'nl',
  ENGLISH = 'en',
  GERMAN = 'de',
  ITALIAN = 'it',
  FRENCH = 'fr',
  BULGARIAN = 'bg',
  UKRAINIAN = 'uk',
  HUNGARIAN = 'hu',
  SPANISH = 'es',
  JAPANESE = 'ja',
  INDONESIAN = 'id',
  VIETNAMESE = 'vi',
  CHINESE_SIMPLIFIED = 'zh-Hans',
  PORTUGUESE_BR = 'pt-BR',
  PORTUGUESE_PT = 'pt',
}

export const AVAILABLE_LANGUAGES_CODES = [
  'en',
  'fr',
  'es',
  'de',
  'it',
  'zh-Hans',
  'pt-BR',
  'pt',
]
